<div class="typeahead-with-icon default-content">
  <div class="typeahead-with-icon-search-container me-1 mb-1">
    <div class="input-group input-group-sm">
      <span class="input-group-text">
        <fa-icon [icon]="['fas', props.icon || 'circle']" [fixedWidth]="true"></fa-icon>
      </span>

      <input class="'form-control typeahead-with-icon-search mb-2'"
        type="text"
        autocomplete="off"
        [formControl]="multiselectTypeaheadFormControl"
        [formlyAttributes]="field"
        [class.is-invalid]="showError"
        [typeahead]="dataSource"
        [typeaheadOptionsLimit]="typeaheadOptionsLimit"
        [typeaheadMinLength]="0"
        [typeaheadLatinize]="true"
        [typeaheadSelectFirstItem]="typeaheadSelectFirstItem"
        [typeaheadIsFirstItemActive]="typeaheadIsFirstItemActive"
        [typeaheadOptionField]="props.shownOption"
        [adaptivePosition]="true"
        (typeaheadOnSelect)="onSelect($event)"
        container="body"
        >
    </div>
  </div>

  @if (items && items.length > 0) {
    <div class="mt-2">
      @for (item of items; track item; let i = $index) {
        @if (props.tooltipOption) {
          <span class="badge-item me-2 mb-2" tooltip="{{ item[props.tooltipOption] }}">
            <fa-icon [icon]="['fas', props.icon || 'circle']"
              [fixedWidth]="true"
              class="me-1">
            </fa-icon>{{ item[props.selectedOption] || item | slice:0:(props.sliceSelectedOption ? props.sliceSelectedOption : 200) }}@if (props.sliceSelectedOption && (item[props.selectedOption] || item).length > (props.sliceSelectedOption || 200)) {
            <span>...</span>
            }<span (click)="unlinkItem(i)" class="times pointer ms-1">&times;</span>
          </span>
        } @else {
          <span class="badge-item me-2 mb-2">
            <fa-icon [icon]="['fas', props.icon || 'circle']"
              [fixedWidth]="true"
              class="me-1">
            </fa-icon>{{ item[props.selectedOption] || item | slice:0:(props.sliceSelectedOption ? props.sliceSelectedOption : 200)  }}@if (props.sliceSelectedOption && (item[props.selectedOption] || item).length > (props.sliceSelectedOption || 200)) {
            <span>...</span>
            }<span (click)="unlinkItem(i)" class="times pointer ms-1">&times;</span>
          </span>
        }
      }
    </div>
  }
</div>
